import React from 'react';
import { FaCheckCircle, FaChevronRight } from 'react-icons/fa';

/**
 * Success Overlay Component
 * Renders an inline success message with explanation and code review
 */
const SuccessOverlay = ({
    challenge,
    onNext,
    onClose,
    renderRichText,
    showCode = true
}) => {
    return (
        <div className="absolute inset-0 z-20 bg-emerald-50/95 dark:bg-[#064e3b]/95 backdrop-blur-md flex flex-col p-6 animate-fadeIn">
            {/* Header */}
            <div className="flex-shrink-0 mb-6 text-center">
                <div className="w-16 h-16 bg-emerald-100 dark:bg-emerald-500 rounded-full flex items-center justify-center mx-auto mb-4 shadow-lg animate-bounce-slow">
                    <FaCheckCircle className="text-emerald-600 dark:text-white text-3xl" />
                </div>
                <h2 className="text-2xl font-bold text-emerald-900 dark:text-white mb-2">Excellent Work!</h2>
                <p className="text-emerald-700 dark:text-emerald-100">You've solved this challenge.</p>
            </div>

            {/* Scrollable Content (Explanation) */}
            <div className="flex-1 overflow-y-auto custom-scrollbar bg-white/50 dark:bg-black/20 rounded-xl p-4 border border-emerald-100 dark:border-emerald-500/30 mb-6">
                <h3 className="font-bold text-emerald-800 dark:text-emerald-200 uppercase tracking-widest text-xs mb-3">
                    Solution Breakdown
                </h3>
                <div className="prose prose-sm dark:prose-invert max-w-none text-gray-700 dark:text-gray-200">
                    {renderRichText(challenge.explanation || challenge.teach || '')}
                </div>

                {/* Solution Code - Collapsible or Mini View */}
                {showCode && (
                    <div className="mt-6 pt-4 border-t border-emerald-200/50 dark:border-emerald-500/30">
                        <h4 className="font-bold text-emerald-800 dark:text-emerald-200 uppercase tracking-widest text-xs mb-2">
                            The Query
                        </h4>
                        <div className="text-xs">
                            {renderRichText(`\`\`\`sql\n${challenge.solution}\n\`\`\``)}
                        </div>
                    </div>
                )}
            </div>

            {/* Footer Actions */}
            <div className="flex-shrink-0 flex flex-col gap-3">
                {onNext && (
                    <button
                        onClick={() => {
                            onClose(); // Reset state via callback
                            onNext();
                        }}
                        className="w-full py-3.5 rounded-xl font-bold text-white bg-gradient-to-r from-emerald-500 to-teal-500 hover:from-emerald-600 hover:to-teal-600 shadow-lg shadow-emerald-500/20 transform hover:scale-[1.02] transition-all flex items-center justify-center gap-2"
                    >
                        Next Challenge <FaChevronRight />
                    </button>
                )}

                <button
                    onClick={onClose}
                    className="w-full py-3 rounded-xl font-semibold text-emerald-700 dark:text-emerald-200 hover:bg-emerald-100 dark:hover:bg-emerald-800/30 transition-colors"
                >
                    Review My Visualization
                </button>
            </div>
        </div>
    );
};

export default SuccessOverlay;
